import { Select } from '@mantine/core';
import { ReactElement, useMemo } from 'react';
import { PractitionerOption } from '@/hooks/usePractitionersByRoles';

interface OnCallPractitionerSelectsProps {
  primaryId: string | null;
  backupId: string | null;
  practitionerOptions: PractitionerOption[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (primaryId: string | null, backupId: string | null) => void;
  compact?: boolean;
}

export function OnCallPractitionerSelects({
  primaryId,
  backupId,
  practitionerOptions,
  disabled = false,
  loading = false,
  onChange,
  compact = false,
}: OnCallPractitionerSelectsProps): ReactElement {
  const backupOptions = useMemo(
    () => practitionerOptions.filter((option) => option.value !== primaryId),
    [practitionerOptions, primaryId]
  );

  return (
    <>
      <Select
        label={compact ? undefined : 'Primary on-call practitioner'}
        placeholder="Select nurse practitioner or supervising physician"
        data={practitionerOptions}
        value={primaryId}
        disabled={disabled || loading}
        searchable
        clearable
        onChange={(value) => onChange(value ?? null, value === backupId ? null : backupId)}
      />
      <Select
        label={compact ? undefined : 'Backup practitioner'}
        placeholder="Optional backup contact"
        data={backupOptions}
        value={backupId}
        disabled={disabled || loading || !primaryId}
        searchable
        clearable
        onChange={(value) => onChange(primaryId, value ?? null)}
      />
    </>
  );
}
